var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 18",
    style: {
      enableBackground: "new 0 0 14 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9,2.6h-3.8L9.8,1.8C9.6,1,8.9,0.5,8,0.5H5.9C5.1,0.5,4.3,1,4.1,1.8L3.8,2.6H0v1h0.9l0.5,10.8       c0.1,1.7,1.5,3.1,3.3,3.1c0,0,0,0,0,0h4.4c0,0,0,0,0,0c1.8,0,3.2-1.4,3.3-3.1L13,3.6h0.9V2.6z M5,2.1c0.1-0.4,0.5-0.6,0.8-0.6H8       c0.4,0,0.7,0.2,0.8,0.6L9,2.6H4.9L5,2.1z M11.5,14.3c-0.1,1.2-1.1,2.2-2.3,2.2c0,0,0,0,0,0H4.7c0,0,0,0,0,0c-1.2,0-2.2-1-2.3-2.2       L1.9,3.6H12L11.5,14.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 5.9,
    transform: "matrix(0.999 -4.538742e-02 4.538742e-02 0.999 -0.4347 0.2468)",
    width: 1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 9.2,
    transform: "matrix(4.496426e-02 -0.999 0.999 4.496426e-02 -1.3815 17.9462)",
    width: 7.7,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c8e8670e3ff68545e876a983bfb75fbc.svg";
export { ForwardRef as ReactComponent };